import compose from 'ia-react-core/~/utils/components/_compose';

import SearchControl from './SearchControl';

export * from './SearchControl';

export default compose<typeof SearchControl>()(SearchControl);
